import {TooltipController} from '../../controllers/TooltipController';

Hop.defineModule('c-tooltip', async (root, params) => {
    const _ctrl = new TooltipController(root, params);

    await _ctrl.initialize();

    return async function destroy() {
        await _ctrl.destroy();
    };
});
